import { MutationTree } from 'vuex';
import authenticationStateType from './authenticationStateType';

export const mutations: MutationTree<authenticationStateType> = {
  SET_GRANTED_PERMISSIONS(state, payload) {
    state.grantedPermissions = payload;
  },
};
